
import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { PanelComponent } from '@components/core/panel/panel.component';
import { EntityService } from '@services/core/entity.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'app-edit-entity',
	templateUrl: './edit_entity.component.html',
	styleUrls: ["./edit_entity.component.css"],
    imports: [PanelComponent, ReactiveFormsModule, NgSelectComponent],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: true,
})
export class EditEntityComponent implements OnInit{
    @Input() entity: any
    @Input() auditors: any
    @Output() close = new EventEmitter()
    @Output() update = new EventEmitter()
    private entityService = inject(EntityService)
	private _fb = inject(FormBuilder)
    private destroyRef = inject(DestroyRef)
    public entityForm: FormGroup 
    protected groups
    protected offices

	ngOnInit(): void {
        this.entityForm = this._fb.group({
            id: [null],
            name: [null, [Validators.required]],
            code: [null, [Validators.required]],
            groupId: [null, [Validators.required]],
            officeId: [null, [Validators.required]],
            auditorId: [null, [Validators.required]],
            enabled: [true]
        })
        if(this.entity) this.setForm()
        this.getGroupsEntities()
        this.getOffices()
	}

    setForm(){
        this.entityForm.patchValue({
            id: this.entity.id,
            name: this.entity.name,
            code: this.entity.code,
            groupId: this.entity.group?.id,
            officeId: this.entity.office?.id,
            auditorId: this.entity.auditor?.id,
            enabled: this.entity.enabled
        })
    }
    
    getGroupsEntities(){
        this.entityService.getGroupsEntities().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
            this.groups = res
        })
    }

    getOffices(){
        this.entityService.getOffices().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
            this.offices = res
        })
    }

    save(){
        this.entityService.updateEntity(this.entityForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
            this.update.emit()
        })
    }

    cancel(){
        this.close.emit()
    }
  
}
